module.exports = __webpack_public_path__ + "img/chevron_left_gray800.cdb5eea0.svg";